import { useEffect, useRef, useState } from 'react'
import { matchPath, useLocation } from 'react-router-dom'

const PAGE_TITLES: [path: string, title: string][] = [
  ['/', 'Home'],
  ['/login', 'Log in'],
  ['/auth/verify', 'Logging in'],
  ['/forgot-password', 'Forgot password'],
  ['/reset-my-password/:id', 'Reset password'],
  ['/password-setup', 'Set up password'],
  ['/team', 'Team login'],
  ['/extra-details', 'Your details'],
  ['/tickets', 'Wallet'],
  ['/seat-map', 'Seat map'],
  ['/swap-dates', 'Swap dates'],
  ['/memberships', 'Memberships'],
  ['/account', 'Account'],
  ['/share-tickets/:id', 'Share tickets'],
  ['/share/:uid', 'Claim tickets'],
  ['/orders', 'Orders'],
  ['/orders/:id', 'Order details'],
  ['/help-centre', 'Help centre'],
  ['/partners', 'Partners'],
  ['/booking-summary', 'Booking summary'],
  ['/fnb-booking-summary', 'Order summary'],
  ['/channel/:id', 'Show content'],
  ['/food-and-drinks', 'Food & drinks'],
  ['/food-and-drinks/confirmation/:id', 'Order confirmed'],
  ['/notifications', 'Notifications'],
  ['/notification/:uid', 'Notification'],
  ['/legals', 'Legal'],
  ['/legals/terms', 'Terms of use'],
  ['/legals/privacy', 'Privacy policy'],
  ['/legals/cookies', 'Cookie policy'],
  ['/legals/:country', 'Legal'],
  ['/legals/:country/terms', 'Terms of use'],
  ['/legals/:country/privacy', 'Privacy policy'],
  ['/legals/:country/cookies', 'Cookie policy'],
]

export const pageTitle = (pathname: string) =>
  PAGE_TITLES.find(([path]) => matchPath(path, pathname))?.[1]

// The first page is read by the screen reader on load, so only later pages are announced
export const PageAnnouncer = () => {
  const { pathname } = useLocation()
  const [message, setMessage] = useState('')
  const isFirstPage = useRef(true)

  useEffect(() => {
    const title = pageTitle(pathname)
    document.title = title ? `${title} | Up` : 'Up'

    if (isFirstPage.current) {
      isFirstPage.current = false
      return
    }
    if (!title) return

    setMessage('')
    const id = window.setTimeout(() => setMessage(title), 100)
    return () => window.clearTimeout(id)
  }, [pathname])

  return (
    <div aria-live="polite" aria-atomic="true" className="sr-only">
      {message}
    </div>
  )
}
